module.exports = __webpack_public_path__ + "5929cc0c05d4a78624e50de54d26d66e.svg";